export const SITE_SIGNATURE_RATES_SIGNATURE_FILTER = [
  'all',
  'signed',
  'unsigned',
] as const;

export const SITE_SIGNATURE_RATES_BREAKDOWN_SORT_BY = [
  'signature_rate',
  'site_name',
  // 'signed_count', // We don't care about those sort options
  // 'total_count',
  // 'unsigned_count',
] as const;
